import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loading } from "@components";
import { message, Form } from "antd";
import DataForm from "./form";
import * as API from "@api";

export default function EditData() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    API.Products.getOne({ id }).then((res) => {
      if (res.error || !res) {
        return message.error("Unable to load data, please try again later.", 2);
      }

      setData(res.data);
      setLoading(false);
    });
  }, []);

  if (!data) {
    return <Loading compact />;
  }

  const onSave = async (values) => {
    setLoading(true);

    const description = form.getFieldValue("description");
    const meta = form.getFieldValue("meta");
    const images = form.getFieldValue("images");
    const normalizedValues = Object.entries(values).reduce(
      (acc, [key, value]) => {
        acc[key] = value !== undefined ? value : null;
        return acc;
      },
      {}
    );

    API.Products.update({
      id,
      ...normalizedValues,
      meta,
      description,
      images,
    })
      .then(async (res) => {
        if (res?.error || !res?.data) {
          throw new Error(res?.message || "Error updating product");
        }

        await API.Revalidate.staticPages();

        await API.Revalidate.wines({ slug: data?.slug });

        if (data?.slug !== res?.data?.slug) {
          await API.Revalidate.wines({ slug: res?.data?.slug });
        }

        return message.success("Product updated successfully", 1);
      })
      .catch((err) => message.error(err.message || "Error updating product", 2))
      .finally(() => setLoading(false));
  };

  const onDelete = () => {
    setLoading(true);

    API.Products.destroy({ id })
      .then(async (res) => {
        if (res?.error || !res?.data) {
          throw new Error(res?.message || "Error deleting product");
        }

        await API.Revalidate.staticPages();
        await API.Revalidate.wines({ slug: data?.slug });

        return message.success(
          "Product deleted successfully",
          1,
          () => (window.location.href = "/products")
        );
      })
      .catch((err) =>
        message.error(err.message || "Error deleting product", 2)
      );
  };

  return (
    <Form
      form={form}
      onFinish={onSave}
      onFinishFailed={(err) =>
        err?.errorFields?.map((msg) => message.error(msg.errors[0], 2))
      }
      layout="vertical"
      className="w-full form-container"
      initialValues={data}
    >
      <DataForm onDelete={onDelete} form={form} data={data} loading={loading} />
    </Form>
  );
}
